import { isTauri } from "@/lib/is-tauri";
import { agentNameKey } from "@/components/cursors/agent-avatar-dock-utils";
import { useCanvasStore } from "@/stores/canvas-store";
import { useNotificationStore } from "@/stores/notification-store";
import { translate } from "@/i18n";
import { libChatMessages } from "@/i18n/messages/lib-chat";

export function acknowledgeDispatchedAgentResult({
  agentKey,
  spaceId,
  executionId,
  sessionId,
}: {
  agentKey: string | undefined;
  spaceId: string | undefined;
  executionId: string | undefined;
  sessionId: string | undefined;
}): void {
  const cursors = [...useCanvasStore.getState().agentCursors.values()].filter(
    (cursor) => cursor.spaceId === spaceId,
  );
  const routedCursor = cursors.find(
    (cursor) =>
      (!!executionId &&
        (cursor.agentId === executionId ||
          cursor.executionId === executionId)) ||
      (!!sessionId && cursor.sessionId === sessionId),
  );
  const namedCursor = agentKey
    ? cursors.find(
        (cursor) => agentNameKey(cursor.name) === agentNameKey(agentKey),
      )
    : undefined;
  const cursor = routedCursor ?? namedCursor;
  if (cursor) {
    useCanvasStore.getState().acknowledgeAgentCursorResult(cursor.agentId);
  }
}

export function reportDispatchUnavailable(): void {
  console.warn(
    "[dispatch-user-message] no WsActions installed; prompt was not sent",
  );
  if (!isTauri()) return;
  useNotificationStore.getState().addSystemToast({
    id: `dispatch-ws-missing-${Date.now()}`,
    title: translate(libChatMessages, "requestDidNotStart"),
    description: translate(libChatMessages, "windowNotConnected"),
    level: "error",
  });
}
